/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_View_Related_LabelInputs */



/**
* | output |
* | --- |
* | "View related events" |
*
* @param {Manual_Qc_View_Related_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_view_related_label = /** @type {((inputs?: Manual_Qc_View_Related_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_View_Related_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Voir les evenements associes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ähnliche Ereignisse anzeigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Visualizza eventi correlati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Просмотреть связанные события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ver eventos relacionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("查看相关活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("関連イベントを見る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संबंधित कार्यक्रम देखें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Veja os eventos relacionados")
	return /** @type {LocalizedString} */ ("View related events")
});